import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import toast from 'react-hot-toast';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const hasRef = params.has('ref');
    console.log('NotFoundPage accessed with ref:', params.get('ref'));
    if (hasRef) {
      toast.error(
        'Landing page not found. Please contact your marketer. Only an administrator can verify or update landing page settings.',
        { duration: 5000 }
      );
    }

    navigate('/', { replace: true });
  }, []);

  return null;
};

export default NotFoundPage;
